/*tslint:disable*/
/*eslint-disable*/
//This file was automatically generated and should not be edited.
import gql from 'graphql-tag';
export const Fragment_LiveCard = gql`
  fragment Fragment_LiveCard on Live {
    id
    title
    localized_path
    entry_date {
      timestamp
    }
    square_image(params: { width: 350, format: webp }) {
      processed_url
    }
    teacher {
      id
      full_name
      image(params: { width: 150, format: webp }) {
        processed_url
      }
    }
    start_date {
      timestamp
      iso8601
    }
    end_date {
      iso8601
      timestamp
      timestamp_seconds
    }
    tags {
      name
    }
    snippet
    content {
      live_zoom {
        id
        jw_channel_id
        jw_playlist_id
        zoom_meeting_url
        zoom_id
        zoom_type
      }
    }
    media_duration {
      group
      seconds
    }
    action_type
  }
`;
